import { Box } from 'rebass'
import { SStyled } from 'styles/theme'
import { mobileMaxWidth } from 'components/BaseComponents/constants'

export const TextAreaContainerStyled = SStyled(Box)`
    border-style: solid;
    border-width: 2px;
    height: 128px;
    overflow: scroll;
    background-color: #F2F2F2;
    border-color: #CCCCCC;
    outline: none;
    padding-left: 20px;
    padding-right: 14px;
    padding-bottom: 24px;
 
    @media screen and (max-width: ${mobileMaxWidth}) {
    
    }
`
